import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import {ReactComponent as LogoBrandmark} from "../assets/images/logo-new-brandmark.svg";
import Layout from "../components/common/Layout";
import TwoFactorVerificationForm from '../components/forms/TwoFactorVerificationForm';
import styles from "../styles/common/TwoFactorVerification.module.scss";

function TwoFactorVerification() {
  const location = useLocation();
  const userId = location.state?.userId;

  // If no userId is provided (e.g., user accessed this page directly), redirect to login
  if (!userId) {
    return <Navigate to="/login" replace />;
  }

  return (
    <Layout
      pageTitle="Two-Factor Authentication - Liquid Credit"
      hideHeader
      pageBodyClassName={styles.twoFactorPage}
    >
      <div className={styles.twoFactorContainer}>
        <div className={styles.logoContainer}>
          <div className={styles.logoIcon}>
            <LogoBrandmark />
          </div>
          <span className={styles.logoText}>Liquid Credit</span>
        </div>

        <div className={styles.twoFactorCard}>
          <div className={styles.twoFactorHeader}>
            <h2 className={styles.twoFactorTitle}>Two-Factor Authentication</h2>
            <p className={styles.twoFactorSubtitle}>
              Please enter the 6-digit verification code from your authenticator app.
            </p>
          </div>

          <TwoFactorVerificationForm userId={userId} />
          
          <div className={styles.supportLink}>
            <span>Having trouble? </span>
            <a href="mailto:support@liquidcredit.co" className={styles.contactLink}>
              Contact Support
            </a>
          </div>
        </div>

        <div className={styles.securityNotice}>
          All transactions on Liquid Credit protected by enterprise-grade security.
        </div>
      </div>
    </Layout>
  );
}

export default TwoFactorVerification;